//mui
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";

//assets
import { ReactComponent as NoDataIcon } from "../../assets/empty_data.svg";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "1rem",
  "& svg": {
    width: "100%",
    height: "100%",
    maxWidth: "360px",
    maxHeight: "360px",
    objectFit: "contain",
  },
  "& .text_style": {
    fontSize: "14px",
    fontWeight: "600",
  }
}));

const NoData = ({ msg }) => {
  return (
    <Container>
      <NoDataIcon />
      <Typography className="text_style">
        {msg ? 
          msg : 
          <>
            <span>Oops!!</span> <span> Data not available</span>
          </>
        }
      </Typography>
    </Container>
  );
};

export default NoData;